import * as d3 from 'd3';

import { TsPoint } from './MultiLineChart.types';

export const drawThresholdFill = (
  ctx: CanvasRenderingContext2D,
  thresholdData: TsPoint[],
  xScale: d3.ScaleTime<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  width: number,
  height: number,
  threshold: number,
  fillColors: {
    positive: string;
    negative: string;
  }
) => {
  const yThreshold = yScale(threshold);
  ctx.clearRect(0, 0, width, height);

  const areaPath = d3
    .area<TsPoint>()
    .x(d => xScale(d.date))
    .y0(yThreshold)
    .y1(d => yScale(d.value))
    .curve(d3.curveLinear)(thresholdData);

  if (!areaPath) {
    return;
  }

  ctx.save();
  ctx.globalCompositeOperation = 'destination-over';

  const path = new Path2D(areaPath);
  ctx.clip(path);

  const bullishColor = fillColors.positive;
  ctx.fillStyle = bullishColor;
  ctx.fillRect(0, 0, width, yThreshold);

  const bearishColor = fillColors.negative;
  ctx.fillStyle = bearishColor;
  ctx.fillRect(0, yThreshold, width, height - yThreshold);
  ctx.restore();
};
